import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-hot-toast';

import { APIUtiltity } from '../../API';
import MainPage from './Components/MainPage.js';
import SlideDrawer from './SlideDrawer/SlideDrawer.js';
import BackDrop from './SlideDrawer/BackDrop.js';
import { NOTIFICATION_MODULES, socket } from '../../config';

import { ReactComponent as NotificationIcon } from '../../img/svg/Actions/Notification.svg';
import { ReactComponent as CloseIcon } from '../../img/svg/CrossMark/CircleCrossGrey.svg';

const NotificationBox = ({
  toastId = '',
  data: { title = '', description = '', moduleName = '', data = '' }
}) => {
  const dissmissable = Object.keys(NOTIFICATION_MODULES).includes(moduleName);
  const history = useHistory();

  return (
    <div className="noti-box text-gray">
      <div
        onClick={() => {
          if (dissmissable) {
            if ((NOTIFICATION_MODULES[moduleName] || '').endsWith('/')) {
              // console.log(NOTIFICATION_MODULES[moduleName], data);
            } else history.push(NOTIFICATION_MODULES[moduleName]);
          }
        }}
        style={dissmissable ? { cursor: 'pointer' } : {}}
        className="d-flex flex-column pe-2"
      >
        <span className="fs-6 text-white">{title}</span>
        <span className="text-gray">{description}</span>
      </div>
      {dissmissable && (
        <div className="noti-close-btn" onClick={() => toast.dismiss(toastId)}>
          <CloseIcon />
        </div>
      )}
    </div>
  );
};

export default function Notification({ walletId = '' }) {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [socketConnected, setSocketConnected] = useState(false);
  const [unreadNotificaitonsCount, setUnreadNotificationsCount] = useState(0);
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);

  async function getNotifications(currentPage = 1) {
    setLoading(true);
    const apiUtility = APIUtiltity;
    if (!walletId) return;
    const res = await apiUtility.getAllNotifications(walletId, currentPage);
    const data = res?.data?.data ? res.data.data : [];
    const totalNoti =
      currentPage > 1 && notifications.length > 0
        ? [...notifications, ...data]
        : data;
    const total = res?.data?.totalCount?.totalRecords
      ? res.data.totalCount.totalRecords
      : 0;
    setNotifications(totalNoti);
    if (total === totalNoti.length) setPage(0);
    else setPage(currentPage + 1);
    setLoading(false);
  }

  useEffect(() => {
    if (walletId) {
      socket.connect();
      socket.on('connect', () => {
        setSocketConnected(true);
        socket.emit('addUser', { walletId });
      });
      socket.on('disconnect', () => setSocketConnected(false));
      socket.on('notification', (data = {}) => {
        if (data?.title) {
          setUnreadNotificationsCount((count = 0) => count + 1);
          toast((t) => <NotificationBox toastId={t.id} data={data} />, {
            icon: <NotificationIcon className="noti-blue-icon" />,
            className: 'noti-wrapper',
            duration: 5000
          });
        }
      });
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') {
          socket.emit('leaveUser', { walletId });
        } else socket.emit('addUser', { walletId });
      });
    } else if (socketConnected) {
      socket.emit('leaveUser', { walletId });
      socket.disconnect();
    }
    return () => {
      socket.offAnyOutgoing();
      socket.disconnect();
      document.removeEventListener('visibilitychange', () => {});
    };
  }, [walletId]);

  return (
    <div>
      <SlideDrawer
        loading={loading}
        notifications={notifications}
        walletId={walletId}
        show={drawerOpen}
        page={page}
        getNotifications={getNotifications}
      />
      {drawerOpen && <BackDrop close={() => setDrawerOpen(false)} />}
      <MainPage
        page={page}
        setUnreadNotificationsCount={setUnreadNotificationsCount}
        toggle={() => setDrawerOpen(!drawerOpen)}
        unreadNotificaitonsCount={unreadNotificaitonsCount}
        getNotifications={getNotifications}
      />
    </div>
  );
}
